import { IconProps } from "./_types";

interface ScrollMoreIconProps extends IconProps {
  bgColor?: string;
  arrowColor?: string;
  bgOpacity?: number;
  arrowOpacity?: number;
}

const ScrollMoreIcon = ({
  size = 36,
  bgColor = "#7D89C2",
  arrowColor = "white",
  bgOpacity = 1,
  arrowOpacity = 1,
  ...other
}: ScrollMoreIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
    >
      <rect width="36" height="36" rx="16" fill={bgColor} opacity={bgOpacity} />
      <path
        d="M17.1914 22.4336L12.6914 17.9336C12.375 17.6172 12.2695 17.125 12.4453 16.7031C12.6211 16.2812 13.043 16 13.5 16H22.5C22.957 16 23.3438 16.2812 23.5195 16.7031C23.6953 17.125 23.5898 17.6172 23.2734 17.9336L18.7734 22.4336C18.3516 22.8906 17.6133 22.8906 17.1914 22.4336Z"
        fill={arrowColor}
        opacity={arrowOpacity}
      />
    </svg>
  );
};

export default ScrollMoreIcon;
